import login, { SWITCH_LANGUAGE } from './login';
import languages from '../languages';

import { getJSON, H5_HOST, PASSPORT_HOST } from '../ultile';

import globalConfig from '../../utiles/globalConfig';
languages.init();

export const RESET_DATA = 'reset_data';

export const SAVE_USER_GAME_INFO = 'save_user_game_info';
export const GET_GAME_LINK = 'get_game_link';
export const GET_BASE_INFO = 'get_base_info';
export const RESET_GAME_LINK = 'reset_game_link';
export const ENTER_GAME = 'enter_game';
export const TOGGLE_NOTICE_STATE = 'toggle_notice_state';
const UPDATE_BASE_INFO = 'update_base_info';
const UPDATE_GAME_LINK = 'update_game_link';

const ENTER_GAME_AJAX = 'web_add_server';
const GET_GAME_LINK_AJAX = 'h5/play_games/enterGameUrl';
const GET_BASE_INFO_AJAX = 'h5/play_games/basic_page_info';
export const QR_CODE_AJAX = 'center/ajax/h5_qrcode';
export const WEBSITE_CODE_AJAX = 'h5/playGames/qrcode';
export const HTTPS = 'https:';

export const forward = encodeURIComponent(window.location.href);
const thirdLoginParam = globalConfig.assignParamsObj(
  globalConfig.getHrefParamObj(),
  {
    forward: forward,
    language: '',
  }
);
const thirdLoginParamStr = globalConfig.objParamsToStrParams(thirdLoginParam);

export const FB_LOGIN_HREF = `${HTTPS}${PASSPORT_HOST}web_facebook/login?${thirdLoginParamStr}`;
export const TWI_LOGIN_HREF = `${HTTPS}${PASSPORT_HOST}web_twitter/login?${thirdLoginParamStr}`;
export const LINE_LOGIN_HREF = `${HTTPS}${PASSPORT_HOST}web_line/login?${thirdLoginParamStr}`;

export default {
  state: {
    gameLink: '',

    floatIcon: '',
    bg: '',
    asideBtnList: [],
    shareList: [],
    isRegisterTerm: true,
    fbTitle: '',
    twitterTitle: '',
    tipsBg: '',

    serverId: '',
    serverName: '',
    roleId: '',
    roleName: '',

    noticeState: false,
  },
  getters: {
    letter: state => {
      return state.login.letter;
    },
    isLogin: state => {
      return state.login.userId;
    },
    gameId: state => {
      return state.login.gameId;
    },
    lang: state => {
      return state.login.lang;
    },
  },
  mutations: {
    [UPDATE_BASE_INFO](state, data) {
      state.bg = data.bg;
      state.floatIcon = data.icon;
      state.shareList = data.share.shareList;
      state.asideBtnList = data.asideBtn;
      state.isRegisterTerm = data.isRegisterTerm;
      state.fbTitle = data.fb_title;
      state.twitterTitle = data.twitterText;
      state.tipsBg = data.tips;
    },
    [UPDATE_GAME_LINK](state, src) {
      state.gameLink = src;
    },
    [RESET_GAME_LINK](state) {
      state.gameLink = '';
    },
    [SAVE_USER_GAME_INFO](state, params) {
      state.serverId = params.serverId;
      state.serverName = params.serverName;
      state.roleId = params.roleId;
      state.roleName = params.roleName;
    },
    [RESET_DATA](state) {
      state.gameLink = '';
      state.serverId = '';
      state.serverName = '';
      state.roleId = '';
      state.roleName = '';
    },
    [TOGGLE_NOTICE_STATE](state, param) {
      state.noticeState = param;
    },
  },
  actions: {
    // 获取游戏链接
    [GET_GAME_LINK]({ commit, state }) {
      return new Promise(resolve => {
        getJSON(HTTPS + H5_HOST + GET_GAME_LINK_AJAX, {
          game_id: state.login.gameId,
        }).then(res => {
          commit(UPDATE_GAME_LINK, res.data.enterUrl);
          resolve();
        });
      });
    },
    // 获取基础信息
    [GET_BASE_INFO]({ commit, dispatch, state }) {
      return new Promise(resolve => {
        getJSON(HTTPS + H5_HOST + GET_BASE_INFO_AJAX, {
          game_id: state.login.gameId,
        }).then(res => {
          if (parseInt(res.res.result, 10) === 1) {
            commit(UPDATE_BASE_INFO, res.res.data);
            dispatch(SWITCH_LANGUAGE, res.res.data.lang);
          }
          resolve();
        });
      });
    },
    // 进入游戏回调
    [ENTER_GAME]({ commit, state }, param) {
      return new Promise(resolve => {
        getJSON(HTTPS + PASSPORT_HOST + ENTER_GAME_AJAX, {
          game_server_sid: param.serverId,
          language: state.login.lang,
          appLanguage: state.login.lang,
          game_id: state.login.gameId,
          ...param.otherParam,
        }).then(res => {
          resolve();
        });
      });
    },
    // 重置数据
    [RESET_DATA]({ commit }) {
      commit(RESET_DATA);
    },
    // 保存用户角色信息
    [SAVE_USER_GAME_INFO]({ commit }, params) {
      commit(SAVE_USER_GAME_INFO, params);
    },
    [TOGGLE_NOTICE_STATE]({ commit }, param) {
      commit(TOGGLE_NOTICE_STATE, param);
    },
  },
  modules: {
    login,
  },
};
